(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTracker.Summary.CollegeClasses",
                    {
                        url: "/CollegeClasses",
                        component: "collegeclasses",
                        PageTitle: "Marketing Tracker Summary - College Classes"
                    });
        }
    ]);

    app
        .component("collegeclasses",
            {
                templateUrl: "App/Tools/MarketingTracker/Summary/CollegeClasses/collegeclasses-template.html",
                controller: collegeClassesController,
                bindings: {
                    year: "<",
                    user: "<",
                    onGetUserEvents: "&",
                    twelveMonths: "<",
                    onGetDoughnuts: "&",
                    eventTypes: "<"
                }
            });

    collegeClassesController.$inject = ["$scope", "userApi", "_", "$filter"];
    function collegeClassesController($scope, userApi, _, $filter) {
        var $ctrl = this;

        /*$ctrl.$onChanges = function () {
           $ctrl.populatePageData();
        };*/

        $scope.$on('selectedEventTypeChange', function (event, args) {
            $ctrl.ui.selectedEventType = args.selectedEventType;
            $ctrl.populatePageData();
        });

        $ctrl.ui = {};
        //$ctrl.ui.eventTypeOptions = ["All", "College Courses", "College Courses - Power of Zero"];
        $ctrl.ui.eventTypeOptions = $ctrl.eventTypes.CollegeCourses.types;
        $ctrl.ui.eventTypeOptions = $filter("orderBy")($ctrl.ui.eventTypeOptions);
        $ctrl.ui.selectedEventType = $ctrl.ui.eventTypeOptions.length > 2 ? $ctrl.ui.eventTypeOptions[0] : $ctrl.ui.eventTypeOptions[1];

        $ctrl.populatePageData = function () {

            var eventTypes = [];
            if ($ctrl.ui.selectedEventType === "All")
                eventTypes = $filter("filter")($ctrl.ui.eventTypeOptions, "!All");
            else
                eventTypes = [
                    $ctrl.ui.selectedEventType
                ];

            $ctrl.TotalSpentOnEvents = 0;
            $ctrl.TotalBusinessClosed = 0;
            $ctrl.TotalCommissionsGenerated = 0;
            $ctrl.TotalLeadsShowed = {};
            $ctrl.TotalAppointmentsSet = {};
            $ctrl.TotalKeptAppointments = {};
            $ctrl.TotalClosedAppointments = {};
            $ctrl.TotalAvgCaseSize = 0;
            $ctrl.Reservations = {};
            $ctrl.Attendees = {};
            $ctrl.Invites = 0;
            $ctrl.TotalKeptAppointments.Referrals = 0;
            $ctrl.TotalKeptAppointments.Clients = 0;
            $ctrl.TotalKeptAppointments.Prospects = 0;
            $ctrl.TotalKeptAppointments.Total = 0;
            $ctrl.TotalAppointmentsSet.Referrals = 0;
            $ctrl.TotalAppointmentsSet.Clients = 0;
            $ctrl.TotalAppointmentsSet.Prospects = 0;
            $ctrl.TotalAppointmentsSet.Total = 0;
            $ctrl.TotalClosedAppointments.Referrals = 0;
            $ctrl.TotalClosedAppointments.Clients = 0;
            $ctrl.TotalClosedAppointments.Prospects = 0;
            $ctrl.TotalClosedAppointments.Total = 0;
            $ctrl.TotalLeadsShowed.Referrals = 0;
            $ctrl.TotalLeadsShowed.Clients = 0;
            $ctrl.TotalLeadsShowed.Prospects = 0;
            $ctrl.TotalLeadsShowed.Total = 0;
            $ctrl.Attendees.Referrals = 0;
            $ctrl.Attendees.Clients = 0;
            $ctrl.Attendees.Prospects = 0;
            $ctrl.Attendees.Total = 0;
            $ctrl.Reservations.Referrals = 0;
            $ctrl.Reservations.Clients = 0;
            $ctrl.Reservations.Prospects = 0;
            $ctrl.Reservations.Total = 0;
            $ctrl.stats = {};

            userApi.getFigAuth($ctrl.user.Id).then(function (figAuthUser) {
                $ctrl.onGetUserEvents({
                    figAuthUserId: figAuthUser.FigAuthUserId,
                    eventTypes: eventTypes
                }).then(function (groups) {
                    ng.forEach(_.uniqBy(groups, function (row) { return row.Id; }),
                        function (row) {
                            assignValues(_.find(groups, function (g) { return row.Id === g.Id; }));
                        });
                    $ctrl.stats.responseRate = $ctrl.Invites > 0
                        ? ($ctrl.Reservations.Prospects / $ctrl.Invites) * 100
                        : 0;
                    if ($ctrl.stats.responseRate < 0) $ctrl.stats.responseRate = 0;
                    $ctrl.responseRate = $ctrl.onGetDoughnuts({ num: $ctrl.stats.responseRate });
                    $ctrl.stats.noShowRate = $ctrl.Reservations.Total > 0
                        ? (($ctrl.Reservations.Total - $ctrl.Attendees.Total) / $ctrl.Reservations.Total) * 100
                        : 0;
                    if ($ctrl.stats.noShowRate < 0) $ctrl.stats.noShowRate = 0;
                    $ctrl.noShowRate = $ctrl.onGetDoughnuts({ num: $ctrl.stats.noShowRate });
                    $ctrl.stats.appointmentSettingRate = $ctrl.TotalLeadsShowed.Total > 0 &&
                        $ctrl.TotalAppointmentsSet.Total > 0
                        ? ($ctrl.TotalAppointmentsSet.Total / $ctrl.TotalLeadsShowed.Total) * 100
                        : 0;
                    if ($ctrl.stats.appointmentSettingRate < 0) $ctrl.stats.appointmentSettingRate = 0;
                    $ctrl.appointmentSettingRate = $ctrl.onGetDoughnuts({ num: $ctrl.stats.appointmentSettingRate });
                    $ctrl.stats.persistencyRate = $ctrl.TotalAppointmentsSet.Total > 0 &&
                        $ctrl.TotalKeptAppointments.Total > 0
                        ? ($ctrl.TotalKeptAppointments.Total / $ctrl.TotalAppointmentsSet.Total) * 100
                        : 0;
                    if ($ctrl.stats.persistencyRate < 0) $ctrl.stats.persistencyRate = 0;
                    $ctrl.persistencyRate = $ctrl.onGetDoughnuts({ num: $ctrl.stats.persistencyRate });
                    $ctrl.stats.closeRate = $ctrl.TotalKeptAppointments.Total > 0 &&
                        $ctrl.TotalClosedAppointments.Total > 0
                        ? ($ctrl.TotalClosedAppointments.Total / $ctrl.TotalKeptAppointments.Total) * 100
                        : 0;
                    if ($ctrl.stats.closeRate < 0) $ctrl.stats.closeRate = 0;
                    $ctrl.closeRate = $ctrl.onGetDoughnuts({ num: $ctrl.stats.closeRate });
                    $ctrl.stats.roi = $ctrl.TotalSpentOnEvents > 0
                        ? (($ctrl.TotalCommissionsGenerated - $ctrl.TotalSpentOnEvents) / $ctrl.TotalSpentOnEvents) *
                        100
                        : 0;
                    if ($ctrl.stats.roi < 0) $ctrl.stats.roi = 0;
                    $ctrl.roi = $ctrl.onGetDoughnuts({ num: $ctrl.stats.roi });

                    $ctrl.TotalAvgCaseSize = ($ctrl.TotalBusinessClosed > 0 && $ctrl.TotalClosedAppointments.Total > 0)
                        ? ($ctrl.TotalBusinessClosed / $ctrl.TotalClosedAppointments.Total)
                        : 0;

                    $ctrl.graphData = [
                        [
                            $ctrl.TotalClosedAppointments.Referrals,
                            $ctrl.TotalKeptAppointments.Referrals,
                            $ctrl.TotalAppointmentsSet.Referrals,
                            $ctrl.TotalLeadsShowed.Referrals,
                            $ctrl.Attendees.Referrals,
                            $ctrl.Reservations.Referrals
                        ],
                        [
                            $ctrl.TotalClosedAppointments.Clients,
                            $ctrl.TotalKeptAppointments.Clients,
                            $ctrl.TotalAppointmentsSet.Clients,
                            $ctrl.TotalLeadsShowed.Clients,
                            $ctrl.Attendees.Clients,
                            $ctrl.Reservations.Clients
                        ],
                        [
                            $ctrl.TotalClosedAppointments.Prospects,
                            $ctrl.TotalKeptAppointments.Prospects,
                            $ctrl.TotalAppointmentsSet.Prospects,
                            $ctrl.TotalLeadsShowed.Prospects,
                            $ctrl.Attendees.Prospects,
                            $ctrl.Reservations.Prospects
                        ]
                    ];
                });
            });
        };

        function assignValues(r) {

            if (r.AppointmentsKept) {
                $ctrl.TotalKeptAppointments.Referrals += r.AppointmentsKept.Referrals;
                $ctrl.TotalKeptAppointments.Clients += r.AppointmentsKept.Clients;
                $ctrl.TotalKeptAppointments.Prospects += r.AppointmentsKept.Prospects;
                $ctrl.TotalKeptAppointments.Total += r.AppointmentsKept.Referrals + r.AppointmentsKept.Clients + r.AppointmentsKept.Prospects;
            }
            if (r.AppointmentsSet) {
                $ctrl.TotalAppointmentsSet.Referrals += r.AppointmentsSet.Referrals;
                $ctrl.TotalAppointmentsSet.Clients += r.AppointmentsSet.Clients;
                $ctrl.TotalAppointmentsSet.Prospects += r.AppointmentsSet.Prospects;
                $ctrl.TotalAppointmentsSet.Total += r.AppointmentsSet.Referrals + r.AppointmentsSet.Clients + r.AppointmentsSet.Prospects;
            }
            if (r.AppointmentsClosed) {
                $ctrl.TotalClosedAppointments.Referrals += r.AppointmentsClosed.Referrals;
                $ctrl.TotalClosedAppointments.Clients += r.AppointmentsClosed.Clients;
                $ctrl.TotalClosedAppointments.Prospects += r.AppointmentsClosed.Prospects;
                $ctrl.TotalClosedAppointments.Total += r.AppointmentsClosed.Referrals + r.AppointmentsClosed.Clients + r.AppointmentsClosed.Prospects;
            }
            if (r.UnitsAttended) {
                $ctrl.TotalLeadsShowed.Referrals += r.UnitsAttended.Referrals;
                $ctrl.TotalLeadsShowed.Clients += r.UnitsAttended.Clients;
                $ctrl.TotalLeadsShowed.Prospects += r.UnitsAttended.Prospects;
                $ctrl.TotalLeadsShowed.Total += r.UnitsAttended.Referrals + r.UnitsAttended.Clients + r.UnitsAttended.Prospects;
            }
            if (r.Attendees) {
                $ctrl.Attendees.Referrals += r.Attendees.Referrals;
                $ctrl.Attendees.Clients += r.Attendees.Clients;
                $ctrl.Attendees.Prospects += r.Attendees.Prospects;
                $ctrl.Attendees.Total += r.Attendees.Referrals + r.Attendees.Clients + r.Attendees.Prospects;
            }
            if (r.Reservations) {
                $ctrl.Reservations.Referrals += r.Reservations.Referrals;
                $ctrl.Reservations.Clients += r.Reservations.Clients;
                $ctrl.Reservations.Prospects += r.Reservations.Prospects;
                $ctrl.Reservations.Total += r.Reservations.Referrals + r.Reservations.Clients + r.Reservations.Prospects;
            }

            $ctrl.Invites += r.Invites;
            $ctrl.TotalCommissionsGenerated += r.TotalCommission;
            $ctrl.TotalSpentOnEvents += r.TotalEventCost;
            $ctrl.TotalBusinessClosed += r.TotalBusinessClosed;
        }
    }

})(window.app, window.angular); //jshint ignore:line